module.exports = __webpack_public_path__ + "assets/img/ja-0e79fc1c.png";